import React from 'react'

const ExpenditureDetails = () => {
  return (
    <div style={{ backgroundColor: '#E6E9D6' }}>
      <div>
        <h3 style={{ backgroundColor: '#22476C', color: 'white', display: 'flex', justifyContent: 'center' }}>Create Expenditure Details</h3>
      </div>
      <div>
        <h6>Expenditure Header</h6>
      </div>
      <div className='my-3 mx-5'style={{display:'grid',gap:'10px'}}>
        <div >
          <label for="schema"style={{width:'8rem'}}>Schema</label>
          <select id="schema" name="schema">
            <option value="">Select Schema</option>
            <option value="schema1">Schema 1</option>
            <option value="schema2">Schema 2</option>
            <option value="schema3">Schema 3</option>
          </select>
        </div>
        <div className="form-check">
          <input type="checkbox" className="form-check-input" id="schemaCheckbox" />
          <label className="form-check-label" htmlFor="schemaCheckbox"> Through Holding Account</label>
        </div>
        <div>
          <label>Project</label>
          <input type='text' />
        </div>
        <div>
          <label>Agency Account Choice</label>
          <select id="schema" name="schema">
            <option value="">Select </option>
            <option value="schema1">1</option>
            <option value="schema2"> 2</option>
          </select>
        </div>
        <div>
          <label>Bank Account</label>
          <select id="schema" name="schema">
            <option value="">Select </option>
            <option value="schema1">1</option>
            <option value="schema2"> 2</option>
          </select>
        </div>
      </div>
      <h6>Linked senctions</h6>
      <div>
        <label>Expenditure Done For</label>
        <select id="schema" name="schema">
          <option value="">Select </option>
          <option value="schema1">1</option>
          <option value="schema2"> 2</option>
        </select>
      </div>
      <div>
        <label>Letter/office order No</label>
        <input type='' />
      </div>
      <div>
        <div>
          <label>Office Order Letter Attachment (if any)</label>
          <input type="file" disabled style={{ marginBottom: '10px' }} />
        </div>
        <h6>Uploaded Sanction Letter</h6>
        <div>
          <label>Sanction Date</label>
          <input type='date' />
        </div>
        <div>
          <label>Actual Tranction Date</label>
          <input type='date' />
        </div>
        <div>
          <label>Total Availabel Amount</label>
          <input type='text' />
        </div>
        <div>
          <label>Total Amount</label>
          <input type='text' />
        </div>
        <div>
          <label>Narration</label>
          <input type='text' />
        </div>
        <div>
          <label>Voucher Number</label>
          <input type='text' />
        </div>
        <h6>Scheme Components Details</h6>
        <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
          <div>
            <label>Scheme Components</label>
            <input type='text' />
          </div>
          <div style={{ display: 'flex',alignItems:'center',gap:'10px' }}>
            <label>Expence Type</label>
            <div style={{ display: 'flex', gap: '10px', border: '1px solid black', width: '10rem', justifyContent: 'center',padding:'5px' }}>
              <div style={{ display: 'grid', justifyContent: 'center' }}>
                <input type='radio' style={{ width: '2rem', height: '2rem' }} />
                <p>Renevue</p>
              </div>
              <div style={{ display: 'grid', justifyContent: 'center' }}>
                <input type='radio' style={{ width: '2rem', height: '2rem' }} />
                <p>Capital</p>
              </div>
            </div>
          </div>
          <div>
            <label>Percentage</label>
            <input type='tel' />
          </div>
          <div>
            <label>Amount</label>
            <input type='tel' />
          </div>
          <button style={{ border: '1px solid #C2C8C4', backgroundColor: '#EBEBED', width: '4rem', height: '1.8rem', borderRadius: '0px', color: 'black', }}><b>Add</b></button>
        </div>
        <h5>Total Amount</h5>
        <h5>Component Amount</h5>
        <h6>Balance Amount</h6>
      </div>
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <div style={{ display: 'flex', gap: '10px' }}>
          <button style={{ border: '2px solid #AAACAF', backgroundColor: '#EBEBED', width: '4rem', height: '1.8rem', borderRadius: '0px', color: '#B6B8AA', }}><b>save</b></button>
          <button style={{ border: '2px solid #AAACAF', backgroundColor: '#EBEBED', width: '4rem', height: '1.8rem', borderRadius: '0px', color: 'black', }}><b>Reset</b></button>
          <button style={{ border: '2px solid #AAACAF', backgroundColor: '#EBEBED', width: '4rem', height: '1.8rem', borderRadius: '0px', color: 'black', }}><b>Back</b></button>
        </div>
      </div>
    </div>
  )
}

export default ExpenditureDetails
